import { render, staticRenderFns } from "./InventoryDetailModal.vue?vue&type=template&id=57a88e30&scoped=true&"
import script from "./InventoryDetailModal.vue?vue&type=script&lang=js&"
export * from "./InventoryDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a88e30",
  null
  
)

export default component.exports